<template>
    <div>
        <div v-if="exists">
            <a class="btn btn-success" id="upvote-btn-exists" v-on:click="handleClickExists">
                    {{upvotes}}
                    <span class="span-caret">&#x25B4;</span>
            </a>
        </div>
        <div v-else>
            <a class="btn btn-success-outline" id="upvote-btn-reg" v-on:click="handleClickReg">
                    {{upvotes}}
                    <span class="span-caret">&#x25B4;</span>
            </a>
        </div>
    </div>
    
</template>


<script>
import firebase from '../services/firebase'

export default {
    name: 'UpvoteButton',
    data: function() {
        return {
            exists: false,
            upvotes: this.num_upvotes
        }
    },
    props: {
        num_upvotes: Number,
        upvoted_by: Array
    },
    methods: {
        handleClickReg: function() {
            this.exists = true;
            ++this.upvotes;          
            this.upvoted_by.push(firebase.auth().currentUser.uid);
            this.$emit('write_upvotes', this.upvotes, this.upvoted_by);
        },
        handleClickExists: function() {
            --this.upvotes;
            this.exists = false;
            var index = this.upvoted_by.indexOf(firebase.auth().currentUser.uid);
            this.upvoted_by.splice(index, 1);
            this.$emit('write_upvotes', this.upvotes, this.upvoted_by);
        }
    },
    mounted: function() {
        if (this.upvoted_by.includes(firebase.auth().currentUser.uid)) {
            this.exists = true;
        }
    },
    computed: {
        currentUser: function() {
            return firebase.auth().currentUser;
        }
    }
}
</script>


<style scoped>

    #upvote-btn-exists {
        padding-top: 7px;
        padding-bottom: 7px;
        padding-left: 18px;
        padding-right: 18px;
        border: none;
        color: white;
        background-color: green;
        font-size:0.96rem;
        cursor: pointer;
    }

    #upvote-btn-reg {
        padding-top: 7px;
        padding-bottom: 7px;
        padding-left: 18px;
        padding-right: 18px;
        color: green;
        background-color: #eee;
        font-size:0.96rem;
        cursor: pointer;
    }

    .span-caret {
        margin-left: 6px;
    }
        
</style>
